/**
 * useFeatureFlag — React subscription to a PostHog feature flag.
 *
 * Returns `false` when PostHog isn't initialized (no key, no network, etc.).
 * That's the intentional safe default: every flag fails closed so CMMD
 * features stay hidden when the flag system is unavailable.
 *
 * Subscribes to PostHog's `onFeatureFlags` so flag changes propagate live
 * without a page reload.
 */

import { useEffect, useState } from "react";

import { getPosthogFeatureFlag, onPosthogFlagsChanged } from "../observability/posthog";

export function useFeatureFlag(flagKey: string): boolean {
  const [enabled, setEnabled] = useState<boolean>(() => getPosthogFeatureFlag(flagKey));

  useEffect(() => {
    setEnabled(getPosthogFeatureFlag(flagKey));
    const unsubscribe = onPosthogFlagsChanged(() => {
      setEnabled(getPosthogFeatureFlag(flagKey));
    });
    return unsubscribe;
  }, [flagKey]);

  return enabled;
}
